var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExterior(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1481.66 1128.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .fil-ext-0 {fill:#456ABE}\n    .fil-ext-1 {fill:#FEFEFE;fill-rule:nonzero}\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fil-ext-0",
    x: -0.14,
    y: -0.03,
    width: 1481.94,
    height: 1128.89,
    rx: 566.88,
    ry: 564.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil-ext-1",
    d: "M597.96 843.79l-312.75 0 0 -559.66 312.75 0 0 61.93 -242.21 0 0 174.8 228.11 0 0 61.12 -228.11 0 0 199.88 242.21 0 0 61.93zm168.11 -214.78l-145.01 -205.36 78.39 0 108.17 158.33 107.39 -158.33 77.58 0 -145.01 205.36 152.85 214.78 -78.38 0 -114.43 -167.74 -116.01 167.74 -77.61 0 152.07 -214.78zm410.3 166.17c10.44,0 21.16,-0.78 32.12,-2.34 10.99,-1.58 19.87,-3.66 26.67,-6.28l0 52.53c-7.32,3.66 -17.78,6.66 -31.37,9.02 -13.58,2.34 -26.64,3.52 -39.18,3.52 -21.94,0 -42.2,-3.8 -60.75,-11.36 -18.56,-7.58 -33.58,-20.79 -45.08,-39.59 -11.48,-18.82 -17.24,-45.2 -17.24,-79.16l0 -244.57 -59.57 0 0 -32.92 60.35 -27.42 27.44 -89.37 40.76 0 0 96.41 121.5 0 0 53.3 -121.5 0 0 242.99c0,25.6 6.15,44.54 18.43,56.82 12.28,12.28 28.08,18.42 47.42,18.42z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExterior);
export default __webpack_public_path__ + "static/media/exterior.cad23645f8a1b1f7a6c6920c187db3bd.svg";
export { ForwardRef as ReactComponent };